import { render, staticRenderFns } from "./WhatsAppPopup.vue?vue&type=template&id=a7061172&scoped=true"
import script from "./WhatsAppPopup.vue?vue&type=script&lang=js"
export * from "./WhatsAppPopup.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppPopup.vue?vue&type=style&index=0&id=a7061172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7061172",
  null
  
)

export default component.exports